import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { authApi } from "@/lib/api";
import { FullscreenLoader } from "@/components/app/ProtectedRoute";

export default function AuthCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = (window.location.hash || "").match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        navigate("/logowanie", { replace: true });
        return;
      }
      try {
        await authApi.googleSession(sessionId);
        await refresh();
        window.history.replaceState(null, "", "/biblioteka");
        navigate("/biblioteka", { replace: true });
      } catch (e) {
        setError("Logowanie przez Google nie powiodło się. Spróbuj ponownie.");
        setTimeout(() => navigate("/logowanie", { replace: true }), 2500);
      }
    })();
  }, [navigate, refresh]);

  if (error) {
    return (
      <div
        data-testid="auth-callback-error"
        className="flex min-h-screen items-center justify-center bg-brand-bg px-4 text-center text-sm text-red-300"
      >
        {error}
      </div>
    );
  }
  return <FullscreenLoader />;
}
